import type { ComponentProps } from 'react';

const Directions = (props: ComponentProps<'svg'>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_106_52066)">
      <g clipPath="url(#clip1_106_52066)">
        <path
          d="M4.78945 11.7539L11.7539 4.78945C11.8207 4.72266 11.9086 4.6875 12 4.6875C12.0914 4.6875 12.1828 4.72266 12.2461 4.78945L19.2105 11.7539C19.2773 11.8207 19.3125 11.9086 19.3125 12C19.3125 12.0914 19.2773 12.1828 19.2105 12.2461L12.2461 19.2105C12.1793 19.2773 12.0914 19.3125 12 19.3125C11.9086 19.3125 11.8172 19.2773 11.7539 19.2105L4.78945 12.2461C4.72266 12.1793 4.6875 12.0914 4.6875 12C4.6875 11.9086 4.72266 11.8172 4.78945 11.7539ZM10.5586 3.59766L3.59766 10.5586C3.21445 10.9418 3 11.4586 3 12C3 12.5414 3.21445 13.0582 3.59766 13.4414L10.5586 20.4023C10.9418 20.7855 11.4586 21 12 21C12.5414 21 13.0582 20.7855 13.4414 20.4023L20.4023 13.4414C20.7855 13.0582 21 12.5414 21 12C21 11.4586 20.7855 10.9418 20.4023 10.5586L13.4414 3.59766C13.0582 3.21445 12.5414 3 12 3C11.4586 3 10.9418 3.21445 10.5586 3.59766ZM14.0848 8.22773C13.923 8.06602 13.6805 8.02031 13.473 8.10469C13.2656 8.18906 13.125 8.39648 13.125 8.625V10.0312H11.4375C10.1965 10.0312 9.1875 11.0402 9.1875 12.2812V13.9688C9.1875 14.4363 9.56367 14.8125 10.0312 14.8125C10.4988 14.8125 10.875 14.4363 10.875 13.9688V12.2812C10.875 11.9719 11.1281 11.7188 11.4375 11.7188H13.125V13.125C13.125 13.3535 13.2621 13.5574 13.473 13.6453C13.684 13.7332 13.9266 13.684 14.0848 13.5223L16.3348 11.2723C16.5527 11.0543 16.5527 10.6957 16.3348 10.4777L14.0848 8.22773Z"
          fill="#EE4F5E"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_106_52066">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_106_52066">
        <rect width="18" height="18" fill="white" transform="translate(3 3)" />
      </clipPath>
    </defs>
  </svg>
);

export default Directions;
